import React from 'react'
import { PLAY_IMG } from '@constant'

export default ({ cover, ...rest }) => {
  return (
    <div style={{ position: 'relative', cursor: 'pointer' }} {...rest}>
      <img style={{ width: '100%' }} src={cover} />

      <img src={PLAY_IMG} className="center" style={{ width: 20 }} />
    </div>
  )
}
